import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "collapse-title" }, " 支付记录 ", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-30" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("关单")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("同步支付结果")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("下载")

import { ref, Ref, reactive, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatNumber, getNumber } from '@/utils/index'
import dayjs from 'dayjs'
import { getDropBoxHandle } from '@/views/ViewsComponents/financial/bankDropBox'
import Api from "@/http/modules/index"
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"

const __default__ = {
    name: "PayHistory"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let { statusFilter, filterType } = PaymentModuleUtils

let {
    'POST/pay_record/conditions': historyListApi,
    //下拉数据
    'POST/financial_banks/drop_list': transferDropListApi,
    //关单
    'POST/pay_record/close_record': closeRecordApi,
    'GET/pay_record/find_children': payDetailListApi,
    'POST/pay_record/payment_call_back': paymentCallBackApi,
    'GET/pay_pool/payer_company_list': payerListApi,
    // 银行回单下载
    'GET/bank_receipt/download': downloadReceiptApi,
} = Api

const searchQuery = ref({
    no: '',
    "payerBankName": "",
    // "payeeBankName": "",
    "payerCompany": "",
    "payeeCompany": "",
    "payAtRange": "",
    "totalAmtRange": {
        "from": undefined,
        "to": undefined
    }
    ,
    "page": 1,
    "size": 30
})
const activeNames = ref('')
const searchDropList = ref([])
const historyList = ref([])
const currentPage = ref(1)
const pageSize = ref(30)
const tableRowCount = ref(0)
const bankNameDropList = ref<any[]>([])
const companyDropList = ref<any[]>([])
const payDetailVisible = ref(false)
const payDetailList = ref([])
const payDetailTableLoading = ref(false)
const pyerList = ref([])
/* const dropObj: any = reactive({
    "bankName": [],// 银行简称
    "company": [],// 公司名称
}) */
const dropObj: {bankName: any[] } = reactive({
  "accountNumber": [],// 账户ID
  "accountName": [],// 账户简称
  "bankName": [],// 银行简称
  "currency": [],// 币种
  "company": [],// 公司名称
})
const tabLoading = ref(false)
let drowKeys = ['bankName', 'company']
/* transferDropListApi({ "accountNumber": "", "bankName": "", "company": "", "accountName": [], "currency": "" }).then((res: any) => {
    drowKeys.map((_str: string) => {
        let tempArr = res.reduce((dropArr: object[], _obj: any) => {
            dropArr.push(_obj[_str])
            return dropArr
        }, [])
        tempArr = Array.from(new Set(tempArr))
        dropObj[_str] = tempArr.map((_key: string) => ({ label: _key, id: _key }))
        bankNameDropList.value = dropObj.bankName
        companyDropList.value = dropObj.company
    })
}) */

getDropBoxHandle().then(obj => {
    for(let key in dropObj) {
      dropObj[key] = obj[key as string]
    }
})
payerListApi().then((res: any) => {
    pyerList.value = res
})
const searchData = (isSearch: boolean) => {
    if (isSearch) {
        currentPage.value = 1
    }
    tabLoading.value = true
    let params = {
        query: {
            "no": searchQuery.value.no,
            "payerBankName": searchQuery.value.payerBankName,
            "payerCompany": searchQuery.value.payerCompany,
            "payeeCompany": searchQuery.value.payeeCompany,
            "totalAmtRange": {
                "from": searchQuery.value.totalAmtRange.from || "",
                "to": searchQuery.value.totalAmtRange.to || ""
            },
            "payAtRange": {
                "from": searchQuery.value.payAtRange ? dayjs(searchQuery.value.payAtRange[0]).format("YYYY-MM-DD") : "",
                "to": searchQuery.value.payAtRange ? dayjs(searchQuery.value.payAtRange[1]).format("YYYY-MM-DD") : ""
            },
        },
        "page": isSearch ? 1 : searchQuery.value.page,
        "size": searchQuery.value.size
    }
    historyListApi(params).then(res => {
        historyList.value = res.data
        tableRowCount.value = res.rowCount
        tabLoading.value = false
    }).catch(res => {
        historyList.value = []
        tableRowCount.value = 0
        tabLoading.value = false
    })
}
searchData(true)
const pageChange = (val: number) => {
    currentPage.value = val
    searchQuery.value.page = val
    searchData(false)
}
const sizeChange = (size: number) => {
    searchQuery.value.size = size
    searchQuery.value.page = 1
    searchData(true)
}
const resetForm = () => {
    searchQuery.value = {
        "no": "",
        "payerBankName": "",
        "payerCompany": "",
        "payeeCompany": "",
        "payAtRange": "",
        "totalAmtRange": {
            "from": undefined,
            "to": undefined
        }
        ,
        "page": 1,
        "size": 30
    }
    searchData(true)
}
const closeOrder = async (id: number | string) => {
    ElMessageBox.confirm(
        "确认关单？",
        'Warning',
        {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
        }
    ).then(() => {
        closeRecordApi({ id } as any).then((res: any) => {
            searchData(false)
        })
    })

}
const getPayDetailList = (id: number) => {
    payDetailVisible.value = true
    payDetailTableLoading.value = true
    if (!payDetailVisible.value) return
    payDetailListApi({ id }).then((res: any) => {
        payDetailList.value = res
        payDetailTableLoading.value = false
    }).catch(() => {
        payDetailTableLoading.value = false
    })
}

const tableHeight = computed(() => window.innerHeight - 195)
const syncResults = (row: any) => {
    let { id, payStatus } = row
    
    paymentCallBackApi({ id, payStatus }).then((res: any) => {

        ElMessage.success("同步成功")
        searchData(false)
        // row.callBackStatus=0
    })

}
const getPaySummaries = (param: any) => {
  const { columns, data } = param
  const sums: string[] = []
  columns.forEach((column: any, index: any) => {
    if (index === 0) {
      sums[0] = '合计'
      return
    }
    const values = data.map((item: any) => Number(item[column.property]))
    if (index === 6) {
      sums[index] = getNumber(values.reduce((prev: any, curr: any) => {
        const value = Number(curr)
        if (!Number.isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0))
    } else {
      sums[index] = ''
    }
  })

  return sums
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, {
      accordion: "",
      modelValue: activeNames.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((activeNames).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { name: "1" }, {
          title: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, { inline: true }, {
              default: _withCtx(() => [
                (_unref(dropObj).bankName.length)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "付款银行"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: searchQuery.value.payerBankName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery.value.payerBankName) = $event)),
                          placeholder: "请选择付款银行"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).bankName, (item, idx) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: idx,
                                label: item.label,
                                value: item.label
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { label: "编号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: searchQuery.value.no,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery.value.no) = $event)),
                      placeholder: "请输入编号",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "付款公司" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: searchQuery.value.payerCompany,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery.value.payerCompany) = $event)),
                      placeholder: "请选择付款公司",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).company, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: item.label,
                            value: item.label
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "收款公司" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: searchQuery.value.payeeCompany,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery.value.payeeCompany) = $event)),
                      placeholder: "请选择收款公司",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pyerList.value, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "时间段" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: searchQuery.value.payAtRange,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchQuery.value.payAtRange) = $event)),
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "费用范围" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: searchQuery.value.totalAmtRange.from,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchQuery.value.totalAmtRange.from) = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_2,
                        _createVNode(_component_el_input_number, {
                          controls: false,
                          modelValue: searchQuery.value.totalAmtRange.to,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchQuery.value.totalAmtRange.to) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_space, { size: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (searchData(true)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: resetForm
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_6,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "show-summary": "",
      "summary-method": getPaySummaries,
      data: historyList.value,
      border: "",
      "max-height": _unref(tableHeight) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "payerCompany",
          label: "付款单位",
          width: "150px",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "payerBankName",
          label: "付款银行",
          width: "150px",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "payerAcc",
          label: "付款账户",
          width: "200px",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "payAt",
          label: "付款时间",
          width: "170px"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(dayjs)(row.payAt).format('YYYY-MM-DD HH:mm:ss')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalNum",
          label: "总计笔数"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payerCurrency",
          label: "币种"
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalAmt",
          label: "合计金额",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "payType",
          label: "付款方式"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.payType == 0 ? '银企直连' : row.payType == 1 ? "手动付款" : '备用金支付'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "payStatus",
          label: "支付状态"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(statusFilter)(row.payStatus)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "callBackStatus",
          label: "同步CO2支付状态",
          width: "170px"
        }, {
          default: _withCtx(({ row }) => [
            (row.callBackStatus == '0')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "成功"))
              : _createCommentVNode("", true),
            (row.callBackStatus == '1')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "失败"))
              : _createCommentVNode("", true),
            (row.callBackStatus == '2')
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "未同步"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "ops",
          label: "操作",
          width: "200px"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (closeOrder(row.id)),
                  disabled: row.payStatus == "PAY_SUCCESS" || row.payType == 0,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"]),
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (getPayDetailList(row.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (syncResults(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, tabLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: tableRowCount.value,
      currentPage: currentPage.value,
      "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((currentPage).value = $event)),
      "page-size": pageSize.value,
      class: "mb-5 mt-5",
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: pageChange,
      onSizeChange: sizeChange
    }, null, 8, ["total", "currentPage", "page-size"]),
    _createVNode(_component_el_dialog, {
      modelValue: payDetailVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((payDetailVisible).value = $event)),
      title: "付款详情",
      width: "60%"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: payDetailList.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "no",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "支付状态"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: row.status == 'PAY_FAILED' ? 'red' : '' })
                }, _toDisplayString(_unref(statusFilter)(row.status)), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "payeeAccountName",
              label: "收款方",
              "show-overflow-tooltip": true
            }),
            _createVNode(_component_el_table_column, {
              prop: "payeeAcc",
              label: "收款账户"
            }),
            _createVNode(_component_el_table_column, {
              prop: "payeeBankName",
              label: "收款银行",
              "show-overflow-tooltip": true
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "金额"
            }),
            _createVNode(_component_el_table_column, {
              prop: "note",
              label: "备注",
              "show-overflow-tooltip": true
            }),
            _createVNode(_component_el_table_column, null, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_eptBtn, {
                  exportFn: _unref(downloadReceiptApi),
                  exportText: '下载',
                  exportParam: {id: row.id}
                }, {
                  default: _withCtx(({exportFn, isLoading}) => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, { onClick: exportFn }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_loading, isLoading]
                    ])
                  ]),
                  _: 2
                }, 1032, ["exportFn", "exportParam"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, payDetailTableLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})